module.exports = __webpack_public_path__ + "static/media/more-products.7838dc7e.png";